<div class="card">
    <div class="card_header">
        <div class="row row_jc_space_btw">
            <div class="flex_title row">
                <p class="title fz_l fw_700">Заканчиваются</p>
            </div>
            <div class="flex row_ai_center">
                <a routerLink="/accounts" class="link td_underline fz_xs color_text_gray">Смотреть все</a>
                <app-pagination *ngIf="!dataMissing && subscriptions.length > 0" [currentPage]="currentPage" [totalItems]="totalItems"
                    [pageSize]="pageSize" (pageChange)="onPageChange($event)"></app-pagination>
            </div>
        </div>
    </div>
    <div class="card_body">
        <app-skeleton *ngIf="isLoading" height="45" margin="15" [count]="6"></app-skeleton>
        <div class="no_data fz_l row row_ai_center row_jc_center color_red" *ngIf="dataMissing">{{typeof dataMissing === 'string' ? dataMissing : 'Данные отсутствуют'}}</div>
        <div *ngFor="let subscription of subscriptions" class="row row_data row_jc_space_btw"> 
            <div class="row">
                <div class="flex_item">
                    <p class="fz_s">Логин: {{subscription.login}}</p>
                    <p class="fz_xs color_text_gray">{{dateFormatterPipe.transform(subscription.expiresAt, 'yyyy-MM-dd HH:mm:ss')}}</p>
                </div>
            </div>
            <div class="flex_item fz_s color_red">Сумма: <span *ngIf="subscription.orderProduct.price > 0">$</span>{{subscription.orderProduct.price}}</div>
        </div>
    </div>
</div>